export default __webpack_public_path__ + "static/media/921efc0e583a03250580870e2c8c1a78.fb93807b.svg";